import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, TableCell } from '@mui/material';

import { DynamicTooltip } from 'shared/ui/Tooltip';

import { getDefaultAlign } from './getDefaultAlign';

import type { ReportWidgetColumnConfig } from '../../model/types';

interface ReportWidgetTableHeaderCellProps {
    column: ReportWidgetColumnConfig;
    measuredWidth?: number;
    isPrinting?: boolean;
}

export const ReportWidgetTableHeaderCell = ({
    column,
    measuredWidth,
    isPrinting = false,
}: ReportWidgetTableHeaderCellProps) => {
    const width =
        isPrinting || measuredWidth == null ? undefined : `${measuredWidth}px`;

    const minWidthNum = isPrinting
        ? undefined
        : measuredWidth ?? column.minWidth;

    const maxWidthNum = isPrinting
        ? undefined
        : measuredWidth ?? column.maxWidth;

    const minWidth = minWidthNum ? `${minWidthNum}px` : undefined;
    const maxWidth = maxWidthNum ? `${maxWidthNum}px` : undefined;

    return (
        <TableCell
            key={column.id}
            align={getDefaultAlign(column)}
            sx={{
                fontWeight: 500,
                fontSize: '13px',
                color: 'text.secondary',
                width,
                minWidth,
                maxWidth,
                whiteSpace: isPrinting ? 'normal' : 'nowrap',
            }}
        >
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                {column.label}
                {column.headerTooltip && (
                    <DynamicTooltip
                        content={column.headerTooltip}
                        containerStyle={{
                            paddingTop: '4px',
                        }}
                    >
                        <InfoOutlinedIcon
                            sx={{
                                fontSize: '14px',
                            }}
                            data-pdf-tooltip="true"
                        />
                    </DynamicTooltip>
                )}
            </Box>
        </TableCell>
    );
};
